export const authRoles = {
  // Only Super Admin has access
  admin: ['ADMIN'], // Only SA & Admin has access
  doctor: ['DOCTOR'],
  specialist: ['SPECIALIST'] // Only SA & Admin & Editor has access
};
